import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SportHomePageContent } from '../../Common/pages/SportHomePageContent';

export default class SnookerHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="snooker"
      title="Snooker News & Betting Tips"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Snooker/containers/SnookerHomePage.js